/**
 * Checks if an array of items with start dates is in reverse chronological order (newest first)
 * 
 * @param items Array of objects containing startDate
 * @returns boolean - true if in correct order (newest first), false if not in reverse chronological order
 */
export const checkReverseOrder = (items: { startDate?: string | null }[]): boolean => {
  // Filter out items without start dates
  const itemsWithDates = items.filter(item => item.startDate);
  
  // If there's only one or no items with dates, there's no ordering issue
  if (itemsWithDates.length <= 1) return true;

  // Check if items are in reverse chronological order (newest first)
  for (let i = 0; i < itemsWithDates.length - 1; i++) {
    const currentDate = new Date(itemsWithDates[i].startDate as string);
    const nextDate = new Date(itemsWithDates[i + 1].startDate as string);
    
    // If current date is earlier than next date, it's not in reverse chronological order
    if (currentDate < nextDate) {
      return false;
    }
  }

  // All items are in correct reverse chronological order
  return true;
};